import { render, staticRenderFns } from "./modalTrasladarProductos.vue?vue&type=template&id=45241bc8&"
import script from "./modalTrasladarProductos.vue?vue&type=script&lang=js&"
export * from "./modalTrasladarProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports